import { render } from "./TourFormRiver.vue?vue&type=template&id=53b5ea9e&scoped=true"
import script from "./TourFormRiver.vue?vue&type=script&lang=js"
export * from "./TourFormRiver.vue?vue&type=script&lang=js"

import "./TourFormRiver.vue?vue&type=style&index=0&id=53b5ea9e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b5ea9e"]])

export default __exports__